import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteProductServiceDevelopBasisApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-product-service-develop-basis'
  }



}